import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Styles from '../../../styles/common/pages.module.css';
import GirlsFashionAge2to6 from '../../../component/girls-fashion/category/GirlsFashionAge2to6';

const GirlsFashionCategoryPage = () => {
    const { ageRange } = useParams();

    let pageContent;

    switch (ageRange) {
        case "2-6":
            pageContent = <GirlsFashionAge2to6 />;
            break;
        case "7-11":
            // pageContent = <FashionAge4to6 />;
            break;
        case "12-14":
            // pageContent = <FashionAge7to9 />;
            break;
        case "15-18":
            // pageContent = <FashionAge10to12 />;
            break;
        case "19-24":
            // pageContent = <FashionAge13to15 />;
            break;
        default:
            // pageContent = <FashionDefault />;
            break;
    }

    return (
        <>
            {/* Main Heading of the Home Page */}
            <h1 className="visually-hidden">Home - Online Shopping App & Website</h1>
            {/* This is the First Section of Home Page */}
            <section className={Styles.headSec}>
                <Container>
                    <h2>Girls Fashion - Age {ageRange?.replace('-', ' to ')} years</h2>
                </Container>
            </section>
            <section>
                <Container>
                    {pageContent}
                </Container>
            </section>
        </>
    );
};

export default GirlsFashionCategoryPage;











// import React from 'react';
// import { useParams } from 'react-router-dom';
// import { Container } from 'react-bootstrap';

// const GirlsFashionCategoryPage = () => {
//     const { ageRange } = useParams();

//     return (
//         <Container className="py-4">
//             <h2>Girls Fashion for Age {ageRange?.replace('-', ' to ')} years</h2>
//             {/* You can fetch and display filtered products based on ageRange here */}
//             <p>Showing trending outfits, accessories, and more for age group {ageRange}.</p>
//         </Container>
//     );
// };

// export default GirlsFashionCategoryPage;
